import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import { renderField, renderTextarea } from '../../../utils/renderFields';
import { submitVolunteer } from '../../../actions/globalConfig';

const propTypes = {
  removeModal: PropTypes.func,
};

const defaultProps = {
  removeModal: () => {
  },
};

class VolunteerForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    return this.props.dispatch(submitVolunteer(values, this.props.removeModal));
  }

  render() {
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;
    return (submitSucceeded) ? (<div className="text-center">Thanks for offering to volunteer with Explore!</div>) : (
      <form onSubmit={handleSubmit(this.submit)}>
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>
        <Field component={renderField} name="name" type="text" label="Name" className="form-control" />
        <Field component={renderField} name="email" type="email" label="Email" className="form-control" />
        <div className="form-check">
          <label className="form-check-label u-textSize-18">
            <Field component="input" type="radio" className="form-check-input" name="volunteer_type" value="op" />
              <span>Camera Operator</span>
          </label>
        </div>
        <div className="form-check">
          <label className="form-check-label u-textSize-18">
            <Field component="input" type="radio" className="form-check-input" name="volunteer_type" value="mod" />
              <span>Moderator</span>
          </label>
        </div>
        <div className="form-check">
          <label className="form-check-label u-textSize-18">
            <Field component="input" type="radio" className="form-check-input" name="volunteer_type" value="both" />
              <span>Both</span>
          </label>
        </div>
        <Field component={renderTextarea} name="body" label="Tell us more about why you'd like to volunteer with explore.org!" className="form-control" />

        <div className="d-flex justify-content-between">
          <div>
            <button className="btn btn-cancel" onClick={(e) => {
              this.props.removeModal(e);
            }}>Cancel
            </button>
          </div>
          <div><input type="submit" value="Submit" id="submit" className="btn btn-primary" disabled={submitting}/></div>
        </div>
      </form>
    );

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: ownProps.removeModal,
  };
};
const VolunteerReduxForm = reduxForm({
  form: 'volunteer',
  validate,
  fields: ['email', 'password', 'remember_me']
})(VolunteerForm);

VolunteerForm.propTypes = propTypes;
VolunteerForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(VolunteerReduxForm);
